module.exports = __webpack_public_path__ + "static/media/5-BIM装饰计量.30d4f383.png";